import gql from 'graphql-tag';

const PROXY_BID_FRAGMENT = gql`
  fragment ProxyBidFragment on ProxyBid {
    amount
    formatted_amount
    is_persistent
  }
`;

export default PROXY_BID_FRAGMENT;
